import {
  checkLocationMultiAppt,
  getCombinedAppointmentTypeData
} from "common/utils";
import {
  useLocationAppointmentTypesQuery,
  useLocationQuery
} from "core/gateways/practice/LocationHooks";
import { useLocationProvidersQuery } from "core/gateways/practice/ProviderHooks";
import { useAppointmentTypesTG } from "core/gateways/tenant";

import { MultiApptWarningMessageBar } from "./appointment-types-multi-appt-warning-message-bar";

export const MultiApptWarning = () => {
  const { data: location } = useLocationQuery();
  const { data: providers } = useLocationProvidersQuery();
  const { data: appointmentTypes } = useLocationAppointmentTypesQuery();

  const { data: appointmentTypesTG } = useAppointmentTypesTG({
    appointmentTypeIds: appointmentTypes?.map(at => at.id) ?? []
  });
  if (
    !(
      providers?.length &&
      appointmentTypes?.length &&
      appointmentTypesTG?.length &&
      location
    )
  )
    return null;

  // Combine tenant gateway's appointment type for group booking data.
  const combinedAppointmentTypeData = getCombinedAppointmentTypeData(
    appointmentTypes!,
    appointmentTypesTG!
  );

  if (!combinedAppointmentTypeData) return null;

  // Check Location Customised appointment types
  const isLocationMultiApptCustomised = combinedAppointmentTypeData.some(at =>
    checkLocationMultiAppt(at)
  );

  // Check Provider Customised appointment types
  const isProviderMultiApptCustomised = providers.some(p => {
    const combinedAppointmentTypeData = getCombinedAppointmentTypeData(
      p.appointmentTypes!,
      appointmentTypesTG!
    );
    return combinedAppointmentTypeData!.some(pat => {
      return checkLocationMultiAppt(pat);
    });
  });

  return (
    <>
      {(isLocationMultiApptCustomised || isProviderMultiApptCustomised) && (
        <MultiApptWarningMessageBar />
      )}
    </>
  );
};
